function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tether-icon_svg__clip0_3636_5549)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
  fill: "#26A17B"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.811 8.782v-.001c-.055.004-.338.021-.971.021-.505 0-.86-.015-.986-.021v.002c-1.944-.086-3.395-.425-3.395-.83 0-.404 1.451-.743 3.395-.83v1.322c.127.01.492.031.994.031.604 0 .907-.025.963-.03V7.125c1.94.086 3.387.425 3.387.829 0 .404-1.447.742-3.387.828zm0-1.795V5.804h2.707V4h-7.37v1.804h2.707v1.183C4.654 7.087 3 7.524 3 8.046c0 .522 1.654.957 3.854 1.059v3.79h1.957V9.104c2.197-.101 3.847-.537 3.847-1.058 0-.522-1.65-.957-3.847-1.059z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tether-icon_svg__clip0_3636_5549"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgTetherIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgTetherIcon;